export enum InfoBoxTheme {
  Orange = 'orange',
  Black = 'black',
  Gray = 'gray',
}
